import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AppConfigService } from '../services/app-config.service';

/**
 * Keeps the Easyship pages closed while the backend has Easyship switched off.
 * Its routes are not served then, so a page that reached for them would only
 * fail — a saved link lands on the Devices page instead.
 */
export const easyshipEnabledGuard: CanActivateFn = () =>
  inject(AppConfigService).isEasyshipEnabled() || inject(Router).createUrlTree(['/devices']);
